// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"styles_menu-item__YToKF"};